// ————————————————————————————
// DESKTOP: .nav-link_item.has-dropdown (hover + click)
// ————————————————————————————
document.querySelectorAll('.nav-link_item.has-dropdown').forEach(item => {
  const trigger = item.querySelector('.nav-link');
  const dropdown = item.querySelector('.nav-dropdown');

  if (!trigger || !dropdown) return;

  function openDropdown(el, dd) {
    el.classList.add('is-open');
    dd.style.maxHeight = dd.scrollHeight + 'px';
  }

  function closeDropdown(el, dd) {
    el.classList.remove('is-open');
    dd.style.maxHeight = null;
  }

  function closeAll(except = null) {
    document.querySelectorAll('.nav-link_item.has-dropdown.is-open').forEach(openItem => {
      if (openItem !== except) {
        closeDropdown(openItem, openItem.querySelector('.nav-dropdown'));
      }
    });
  }

  // Hover (desktop only)
  item.addEventListener('mouseenter', () => {
    if (window.matchMedia('(hover: hover)').matches) {
      closeAll(item);
      openDropdown(item, dropdown);
    }
  });

  item.addEventListener('mouseleave', () => {
    if (window.matchMedia('(hover: hover)').matches) {
      closeDropdown(item, dropdown);
    }
  });

});

const nav = document.querySelector('.nav-link_holder');

window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    nav.classList.add('is-scrolled');
  } else {
    nav.classList.remove('is-scrolled');
  }
});

// ————————————————————————————
// MOBILE: .main-link.has-dropdown (icon tap toggle)
// ————————————————————————————
document.querySelectorAll('.main-link.has-dropdown').forEach(item => {
  const icon = item.querySelector('.dropdown-icn');
  const dropdown = item.querySelector('.nav-dropdown');

  if (!icon || !dropdown) return;

  function openDropdown() {
    item.classList.add('is-open');
    dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
    icon.classList.add('is-open');
  }

  function closeDropdown() {
    item.classList.remove('is-open');
    dropdown.style.maxHeight = null;
    icon.classList.remove('is-open');
  }

  function closeAll(except = null) {
    document.querySelectorAll('.main-link.has-dropdown.is-open').forEach(openItem => {
      if (openItem !== except) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.nav-dropdown').style.maxHeight = null;
        openItem.querySelector('.dropdown-icn')?.classList.remove('is-open');
      }
    });
  }

  icon.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    const isOpen = item.classList.contains('is-open');
    closeAll(item);
    isOpen ? closeDropdown() : openDropdown();
  });
});

// ————————————————————————————
// SHARED: outside click + Escape
// ————————————————————————————
document.addEventListener('click', e => {
  if (!e.target.closest('.nav-link_item.has-dropdown')) {
    document.querySelectorAll('.nav-link_item.has-dropdown.is-open').forEach(item => {
      item.classList.remove('is-open');
      item.querySelector('.nav-dropdown').style.maxHeight = null;
    });
  }
});

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    [...document.querySelectorAll('.nav-link_item.has-dropdown.is-open'),
     ...document.querySelectorAll('.main-link.has-dropdown.is-open')].forEach(item => {
      item.classList.remove('is-open');
      item.querySelector('.nav-dropdown').style.maxHeight = null;
      item.querySelector('.dropdown-icn')?.classList.remove('is-open');
    });
  }
});

$('.banner-link a, a[href^="#signup"]').on('click', function(e) {
  let link = $(this).attr("href");
  if (!link) return;

  const forms = {
    '#signup': {
      mobile: 'S8QjqR',
      desktop: 'Tbcqf5'
    },
    '#signupo2': {
      mobile: 'XaXc6F',
      desktop: 'XXmfs5'
    },
    '#signuppt': {
      mobile: 'WHqYaD',
      desktop: 'S2vKCA'
    },
    '#signupkt': {
      mobile: 'Xq2gTR',
      desktop: 'RfDz9H'
    },
    '#signupnew': {
      mobile: 'Vzkvjk',
      desktop: 'RjVbA8'
    }
  };

  if (forms[link]) {
    e.preventDefault();

    const isMobile = window.innerWidth <= 768;
    const formId = isMobile ? forms[link].mobile : forms[link].desktop;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }
});

// show klaviyo forms
$('a.expanding-btn, .club-card_btn_holder a').on('click',function(e){
  let link = $(this).attr("href");
  if( link == '#o2'){
    e.preventDefault();
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'XwyQii']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WB3LsC']);
    }
  
  } else if(link == '#wandsworth') {
    e.preventDefault();
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WYZi9p']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'UAnS66']);
    }
  }
})

$('a.klaviyo-modal-btn').on('click',function(e){
  let link = $(this).attr("href");
  if( link == '#stayupdated'){
    e.preventDefault();
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'WYZi9p']); 
    } else {
     window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'WYZi9p']); 
    }
  
  } 
})

$('.footer-layout a.form-button').on('click',function(e){
  let link = $(this).attr("href");
  if( link == '#signup'){
    e.preventDefault();
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'Tbcqf5']); 
    } else {
     window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'Tbcqf5']); 
    }
  
  } 
})

// Klaviyo form success handling (centralized from theme.liquid)
if (window.KlaviyoSubscribe && typeof window.KlaviyoSubscribe.attachToForms === 'function') {
  window.KlaviyoSubscribe.attachToForms('#onsite_signup', {
    hide_form_on_success: true,
    success_url: "/pages/sign-up?su=1"
  });

  window.KlaviyoSubscribe.attachToForms('#onsite_signup-02', {
    hide_form_on_success: true,
    success_url: "/pages/o2-sign-up?su=1"
  });
}

// $('a[href="#signupo2"]').on('click', function(e) {
//   e.preventDefault();
//   window._klOnsite = window._klOnsite || [];

//    if (window.innerWidth <= 768) {
//     window._klOnsite.push(['openForm', 'XaXc6F']);
//   } else {
//     window._klOnsite.push(['openForm', 'XXmfs5']);
//   }

  
// });

// $('a[href="#signuppt"]').on('click', function(e) {
//   e.preventDefault();
//   window._klOnsite = window._klOnsite || [];

//    if (window.innerWidth <= 768) {
//     window._klOnsite.push(['openForm', 'WHqYaD']);
//   } else {
//     window._klOnsite.push(['openForm', 'URZQCs']);
//   }

  
// });


// $('a[href="#signupkt"]').on('click', function(e) {
//   e.preventDefault();
//   window._klOnsite = window._klOnsite || [];

//    if (window.innerWidth <= 768) {
//     window._klOnsite.push(['openForm', 'Xq2gTR']);
//   } else {
//     window._klOnsite.push(['openForm', 'RfDz9H']);
//   }

  
// });


// provided scripts taken from HTML file

gsap.config({
  nullTargetWarn: false,
});
gsap.registerPlugin(DrawSVGPlugin);
const lenis = new Lenis();
lenis.on("scroll", (e) => { });
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
document.querySelectorAll("[text-appear]").forEach((element) => {
  let textAppear = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 85%",
      toggleActions: "play none none none",
    },
  });
  textAppear.from(element, {
    opacity: 0,
    yPercent: 10,
    duration: 0.6,
  });
});
//Only desktop scripts
let mm = gsap.matchMedia();
mm.add("(min-width: 992px)", () => {
  //NAV
  let navShrink = gsap.timeline({
    scrollTrigger: {
      trigger: ".page-wrap",
      start: "top -5%",
      end: "top -10%",
      toggleActions: "play none reverse none",
    },
  });
  navShrink.to(
    ".nav",
    {
      backgroundColor: "#141419",
      duration: 0.4,
      paddingTop: "1rem",
      paddingBottom: "1rem",
      ease: "power1.inOut",
      top: "0rem",
    },
    "<",
  );
  navShrink.to(
    ".nav",
    {
      color: "#fff",
      duration: 0,
      ease: "none",
    },
    "<",
  );
  navShrink.to(
    ".banner-top",
    {
      yPercent: "-100",
      duration: 0.4,
      ease: "power1.inOut",
    },
    "<",
  );
  let reviewImages = gsap.timeline({});
  reviewImages.fromTo(
    ".review-col.is-1, .review-col.is-3",
    {
      yPercent: 0,
    },
    {
      yPercent: -10,
      ease: "none",
      scrollTrigger: {
        trigger: ".review-wrap",
        start: "top bottom",
        end: "bottom top",
        scrub: 5,
      },
    },
  );
  reviewImages.fromTo(
    ".review-col.is-2",
    {
      yPercent: 0,
    },
    {
      yPercent: 10,
      ease: "none",
      scrollTrigger: {
        trigger: ".review-wrap",
        start: "top bottom",
        end: "bottom top",
        scrub: 5,
      },
    },
  );
  let staggerImages = gsap.timeline({
    scrollTrigger: {
      trigger: ".stagger-card_wrap",
      start: "top bottom",
      toggleActions: "play none none none",
    },
  });
  staggerImages.from(".stagger-card", {
    y: "80px",
    duration: 1,
    ease: "power1.out",
    stagger: {
      each: 0.15,
    },
  });
});
//FAQ ACCORDION
$(".faq-holder_top").on("click", function () {
  $(this).siblings(".faq-holder_bot").toggleClass("grid-reveal");
});
//FAQ ARROW
$(".faq-holder_top").each(function () {
  $(this).on("click", function () {
    $(this).find(".faq-arrow").toggleClass("active");
  });
});
//DRAW ON PAGELOAD
gsap.timeline().fromTo(
  "[page-load-draw]",
  {
    scaleY: "0%",
    transformOrigin: "top",
  },
  {
    scaleY: "100%",
    ease: "power3.out",
    duration: 1,
  },
);
//SINGLE PAGE NEXT PREV
//DRAWING LINES HOMEPAGE
$("[draw-svg]").each(function (index) {
  let svgPath = $(this).find("path");
  let strokeSvg = gsap.timeline({
    scrollTrigger: {
      trigger: this,
      start: "top 60%",
      scrub: true,
    },
  });
  strokeSvg.fromTo(
    svgPath,
    {
      drawSVG: "100% 100%",
      duration: 2,
    },
    {
      drawSVG: "0% 100%",
    },
  );
});
$("[draw-events-svg]").each(function (index) {
  let svgPath = $(this).find("path");
  let strokeSvg = gsap.timeline({
    scrollTrigger: {
      trigger: this,
      start: "top 90%",
      scrub: true,
    },
  });
  strokeSvg.fromTo(
    svgPath,
    {
      drawSVG: "100% 100%",
      duration: 2,
    },
    {
      drawSVG: "0% 100%",
    },
  );
});
$("[draw]").each(function (index) {
  let drawSvg = gsap.timeline({});
  drawSvg.fromTo(
    $(this),
    {
      scaleY: "0%",
      transformOrigin: "top",
    },
    {
      scaleY: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: $(this),
        start: "top 90%",
        end: "top 60%",
        scrub: true,
      },
    },
  );
});
$("[draw3]").each(function (index) {
  let drawSvg3 = gsap.timeline({});
  drawSvg3.fromTo(
    $(this),
    {
      scaleY: "0%",
      transformOrigin: "top",
    },
    {
      scaleY: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: $(this),
        start: "top 80%",
        end: "top 30%",
        scrub: true,
      },
    },
  );
});
$("[draw-footer2]").each(function (index) {
  let drawSvg1 = gsap.timeline({});
  drawSvg1.fromTo(
    $(this),
    {
      scaleY: "0%",
      transformOrigin: "top",
    },
    {
      scaleY: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: $(this),
        start: "top 115%",
        end: "top 80%",
        scrub: true,
      },
    },
  );
});
// //CLUBS SLIDER1
const offerSlider = new Swiper(".swiper.is-offer", {
  // Parameters
  navigation: {
    nextEl: ".court-btn_next",
    prevEl: ".court-btn_prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  loop: true,
  centeredSlides: false,
  speed: 400,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
const singleSlider = new Swiper(".swiper.is-single", {
  // Parameters
  navigation: {
    nextEl: ".single-slider_next",
    prevEl: ".single-slider_prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  loop: true,
  centeredSlides: false,
  speed: 400,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
// //EARLS COURT SLIDER
const heroSlider = new Swiper(".swiper.is-hero", {
  // Parameters
  navigation: {
    nextEl: ".hero-btn_next",
    prevEl: ".hero-btn_prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  centeredSlides: false,
  speed: 400,
  loop: true,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
// // SINGLE CLUB SLIDER
function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
$(".slider-gallery_component").each(function (index) {
  const component = $(this);

  const thumbsSwiper = new Swiper(component.find(".swiper.is-slider-thumbs")[0], {
    slidesPerView: 4,
    speed: 400,
    slideToClickedSlide: true,
    slideActiveClass: "swiper-slide-thumb-active",
  });

  const bgSwiper = new Swiper(component.find(".swiper.is-slider-bg")[0], {
    slidesPerView: 1,
    speed: 400,
    effect: "fade",
    allowTouchMove: false,
    breakpoints: {
      320: { allowTouchMove: true },
      992: { allowTouchMove: false },
    },
    thumbs: { swiper: thumbsSwiper },
  });

  const textSwiper = new Swiper(component.find(".swiper.is-slider-titles")[0], {
    slidesPerView: 1,
    effect: "fade",
    speed: 400,
    centeredSlides: false,
    allowTouchMove: false,
    slideActiveClass: "is-active",
  });

  bgSwiper.controller.control = thumbsSwiper;
  bgSwiper.controller.control = textSwiper;

  const slideMap = {};
  component.find(".swiper.is-slider-bg .swiper-slide").each(function (i) {
    const id = $(this).data("slide-id");
    if (id) slideMap[id] = i;
  });

  function goToSlide(id) {
    if (slideMap[id] === undefined) return;

    lenis.scrollTo(component[0], {
      onComplete: () => {
        bgSwiper.slideTo(slideMap[id]);
      }
    });
  }

  // Check hash on page load
  const hash = window.location.hash.replace("#", "");
  if (hash && slideMap[hash] !== undefined) {
    setTimeout(() => goToSlide(hash), 100);
  }

  // Anchor link clicks
  $("a[href^='#']").on("click", function (e) {
    const id = $(this).attr("href").replace("#", "");
    if (slideMap[id] !== undefined) {
      e.preventDefault();
      history.pushState(null, null, "#" + id);
      goToSlide(id);
    }
  });
});
// CLUB SLIDERS
$(".club-swiper").each(function (index) {
  let swiperEl = $(this).find(".club-image_slider");
  let swiperNext = $(this).find(".club-next");
  let swiperPrev = $(this).find(".club-prev");
  const clubSwiper = new Swiper(swiperEl[0], {
    // Parameters
    navigation: {
      nextEl: swiperNext[0],
      prevEl: swiperPrev[0],
    },
    slidesPerView: 1,
    autoplay: false,
    loop: true,
    speed: 800,
    spaceBetween: 0,
  });
});
//MEMBERSHIP SLIDER1
const mem1Slider = new Swiper(".swiper.mem1", {
  // Parameters
  navigation: {
    nextEl: ".mem1-next",
    prevEl: ".mem1-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 1,
    },
  },
  freeMode: true,
  loop: true,
  speed: 800,
  spaceBetween: 0,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
//MEMBERSHIP SLIDER2
const mem2Slider = new Swiper(".swiper.mem2", {
  // Parameters
  navigation: {
    nextEl: ".mem2-next",
    prevEl: ".mem2-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 1,
    },
  },
  loop: true,
  freeMode: true,
  speed: 800,
  spaceBetween: 0,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
//MEMBERSHIP SLIDER3
const mem3Slider = new Swiper(".swiper.mem3", {
  // Parameters
  navigation: {
    nextEl: ".mem3-next",
    prevEl: ".mem3-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 1,
    },
  },
  loop: true,
  freeMode: true,
  speed: 800,
  spaceBetween: 0,
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
});
// MARQUEE POWER-UP
// attribute value checker
function attr(defaultVal, attrVal) {
  const defaultValType = typeof defaultVal;
  if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
  if (attrVal === "true" && defaultValType === "boolean") return true;
  if (attrVal === "false" && defaultValType === "boolean") return false;
  if (isNaN(attrVal) && defaultValType === "string") return attrVal;
  if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
  return defaultVal;
}
// marquee component
$("[tr-marquee-element='component']").each(function (index) {
  let componentEl = $(this),
    panelEl = componentEl.find("[tr-marquee-element='panel']"),
    triggerHoverEl = componentEl.find("[tr-marquee-element='triggerhover']"),
    triggerClickEl = componentEl.find("[tr-marquee-element='triggerclick']");
  let speedSetting = attr(100, componentEl.attr("tr-marquee-speed")),
    verticalSetting = attr(false, componentEl.attr("tr-marquee-vertical")),
    reverseSetting = attr(false, componentEl.attr("tr-marquee-reverse")),
    scrollDirectionSetting = attr(
      false,
      componentEl.attr("tr-marquee-scrolldirection"),
    ),
    scrollScrubSetting = attr(
      false,
      componentEl.attr("tr-marquee-scrollscrub"),
    ),
    moveDistanceSetting = -100,
    timeScaleSetting = 1,
    pausedStateSetting = false;
  if (reverseSetting) moveDistanceSetting = 100;
  let marqueeTimeline = gsap.timeline({
    repeat: -1,
    onReverseComplete: () => marqueeTimeline.progress(1),
  });
  if (verticalSetting) {
    speedSetting = panelEl.first().height() / speedSetting;
    marqueeTimeline.fromTo(
      panelEl,
      { yPercent: 0 },
      {
        yPercent: moveDistanceSetting,
        ease: "none",
        duration: speedSetting,
      },
    );
  } else {
    speedSetting = panelEl.first().width() / speedSetting;
    marqueeTimeline.fromTo(
      panelEl,
      { xPercent: 0 },
      {
        xPercent: moveDistanceSetting,
        ease: "none",
        duration: speedSetting,
      },
    );
  }
  let scrubObject = { value: 1 };
  ScrollTrigger.create({
    trigger: "body",
    start: "top top",
    end: "bottom bottom",
    onUpdate: (self) => {
      if (!pausedStateSetting) {
        if (scrollDirectionSetting && timeScaleSetting !== self.direction) {
          timeScaleSetting = self.direction;
          marqueeTimeline.timeScale(self.direction);
        }
        if (scrollScrubSetting) {
          let v = self.getVelocity() * 0.006;
          v = gsap.utils.clamp(-60, 60, v);
          let scrubTimeline = gsap.timeline({
            onUpdate: () => marqueeTimeline.timeScale(scrubObject.value),
          });
          scrubTimeline.fromTo(
            scrubObject,
            { value: v },
            {
              value: timeScaleSetting,
              duration: 0.5,
            },
          );
        }
      }
    },
  });
  function pauseMarquee(isPausing) {
    pausedStateSetting = isPausing;
    let pauseObject = { value: 1 };
    let pauseTimeline = gsap.timeline({
      onUpdate: () => marqueeTimeline.timeScale(pauseObject.value),
    });
    if (isPausing) {
      pauseTimeline.fromTo(
        pauseObject,
        { value: timeScaleSetting },
        {
          value: 0,
          duration: 0.5,
        },
      );
      triggerClickEl.addClass("is-paused");
    } else {
      pauseTimeline.fromTo(
        pauseObject,
        { value: 0 },
        {
          value: timeScaleSetting,
          duration: 0.5,
        },
      );
      triggerClickEl.removeClass("is-paused");
    }
  }
  if (window.matchMedia("(pointer: fine)").matches) {
    triggerHoverEl.on("mouseenter", () => pauseMarquee(true));
    triggerHoverEl.on("mouseleave", () => pauseMarquee(false));
  }
  triggerClickEl.on("click", function () {
    !$(this).hasClass("is-paused") ? pauseMarquee(true) : pauseMarquee(false);
  });
});
//mobile
let mmobile = gsap.matchMedia();
mmobile.add("(max-width: 991px)", () => {
  //MEMBERSHIP SLIDER1
  const mobilememSlider = new Swiper(".swiper.mobile-mem", {
    // Parameters
    navigation: {
      nextEl: ".mobilemem-next",
      prevEl: ".mobilemem-prev",
    },
    loop: false,
    slidesPerView: 1,
    centeredSlides: false,
    speed: 800,
    spaceBetween: 0,
    slideNextClass: "swiper-button-next",
    slidePrevClass: "swiper-button-prev",
  });
  mobilememSlider.on("slideChange", function (e) {
    let mobilememSlider = e.realIndex + 1;
    $(".swiper-number-current").text(slideNumber);
  });
  var projectCount = $(".swiper-slide.is-club").length;
  $(".swiper-number-total").text(projectCount);
  //HOME PAGE SLIDERS
  const clubSlider = new Swiper(".swiper.is-club", {
    // Parameters
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1.1,
    speed: 800,
    freeMode: {
      enabled: true,
      momentumRatio: 0.1,
      sticky: true,
    },
    slidesOffsetAfter: 20,
    // slidesOffsetBefore: 20,
    spaceBetween: 10,
    // loop: true,
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
  });
  // textSwiper.controller.control = thumbsSwiper;
  clubSlider.on("slideChange", function (e) {
    let slideNumber = e.realIndex + 1;
    $(".swiper-number-current").text(slideNumber);
  });
  var projectCount = $(".swiper-slide.is-club").length;
  $(".swiper-number-total").text(projectCount);
  let navShrink = gsap.timeline({
    scrollTrigger: {
      trigger: ".page-wrap",
      start: "top -5%",
      end: "top -10%",
      toggleActions: "play none reverse none",
    },
  });
  navShrink.to(".nav", {
    color: "#fff",
    backgroundColor: "#141419",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    duration: 0.4,
    ease: "power1.inOut",
    top: "0px",
  });
  // navShrink.to(
  //   ".banner-top",
  //   {
  //     yPercent: -100,
  //     duration: 0.4,
  //     ease: "power1.inOut",
  //   },
  //   "<",
  // );
  $(".stagger-card").each(function (index) {
    let staggerImages = gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        start: "top bottom",
        toggleActions: "play none none none",
      },
    });
    staggerImages.from($(this), {
      y: "80px",
      duration: 1,
      ease: "power1.out",
    });
  });
  $(".club-swiper").each(function (index) {
    let swiperEl = $(this).find(".club-image_slider");
    let swiperNext = $(this).find(".club-next");
    let swiperPrev = $(this).find(".club-prev");
    const clubSwiper = new Swiper(swiperEl[0], {
      // Parameters
      navigation: {
        nextEl: swiperNext[0],
        prevEl: swiperPrev[0],
      },
      slidesPerView: 1,
      autoplay: false,
      loop: true,
      speed: 800,
      spaceBetween: 0,
    });
  });
});
$(".mobile-menu_btn").on("click", function () {
  $(".page-overlay").toggleClass("dark");
  setTimeout(function () {
    $(".mobile-menu").toggleClass("hidden");
  }, 500);
});
$(".text-field").on("focusin", function () {
  $(this).siblings(".text-field_label").addClass("active");
});
$(".text-field").on("focusout", function () {
  if ($(this).val().length == 0) {
    $(this).siblings(".text-field_label").removeClass("active");
  }
});
$(".dropdown").on("focusin", function () {
  $(this).siblings(".text-field_label").addClass("active");
});
$(".dropdown").on("focusout", function () {
  if ($(this).val().length == 0) {
    $(this).siblings(".text-field_label").removeClass("active");
  }
});











// custom

$('a').each(function () {
  var a = new RegExp('/' + window.location.host + '/');
  if (!a.test(this.href) 
    && !this.href.includes('klaviyo') 
    && !this.href.includes('kmail-lists.com')
    && !this.href.includes('padel-sc.myshopify.com')
    && !this.href.startsWith('/')
    && !this.href.startsWith('#')
  ) {
    $(this).attr("target", "_blank");
  }
});


$('.filter-item_target').click(function(){
  var my_target = $(this).attr('data-target');
  $('.posts-grid_item').show();
  $('.filter-item').removeClass('is-active');
  $(this).addClass('is-active');

  fetch(my_target + "?section_id=main-blog")
    .then((response) => response.text())
    .then((blogData) => {
      var blog_html = $(blogData);
      var blog_items = $(".posts-grid_wrapper", blog_html);
      $(".posts-grid_wrapper").replaceWith(blog_items);
    });
});

$('.filter-item_past').click(function(){
  $('.posts-grid_item').hide();
  $('.past').show();
  $('.filter-item').removeClass('is-active');
  $(this).addClass('is-active');
});
$('.filter-item_up').click(function(){
  $('.posts-grid_item').hide();
  $('.upcoming').show();
  $('.filter-item').removeClass('is-active');
  $(this).addClass('is-active');
});


if($('.banner-link').length > 0) {
  $('.banner-link').slick({
    speed: 20000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: false,
    buttons: false,
    mobileFirst:true,
    responsive: [
      {
        breakpoint: 992,
        settings: "unslick"
      }
    ]
  });
  $(window).on('resize orientationchange', function(){
    $('.banner-link').slick('resize');
  });
}

if($('.modal-trigger').length > 0) {
  $('.modal-trigger').click(function (e) {
    e.preventDefault();

    var activeTab = $(this).attr('href');
    $(activeTab).show().fadeIn();
    return false;
  })

  $('.modal-close').click(function () {
    $('.modal-wrapper').fadeOut();
  })
}


$( document ).ready(function() {
  var mainVideo = $('#hero-section__video');
  var desktopVideo= mainVideo.attr("data-desk");
  var mobileVideo=mainVideo.attr("data-mobi");
  
  if ($(window).width() < 1000) {
    mainVideo.append("<source type='video/mp4' src='" + mobileVideo + "' />");
  } else {
    mainVideo.append("<source type='video/mp4' src='" + desktopVideo + "' />");
  }
});


// mainVideo.append("<source type='video/webm' src='" + webMSrc + "' />");

// Wait until sources are appended to call MediaElements.js
// mainVideo.mediaelementplayer();
